import { render, staticRenderFns } from "./FooterGovFederal.vue?vue&type=template&id=d1e304be&"
import script from "./FooterGovFederal.vue?vue&type=script&lang=js&"
export * from "./FooterGovFederal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports